import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
const galleryItems = [{
  label: 'Ramos de flores',
  img: 'https://cdn.magicpatterns.com/uploads/wf3vCw4ZPhybfLxVU8o6zW/RAMOS_DE_FLORES.jpg',
  isImage: true
}, {
  label: 'Diseños personalizados',
  img: 'https://cdn.magicpatterns.com/uploads/5ek3BGw9TtTJLtu5t4xRzp/DISENOS_PERSONALIZADOS.jpg',
  isImage: true
}, {
  label: 'Cuadros decorativos',
  img: 'https://cdn.magicpatterns.com/uploads/tz5QMoASfBNS71siRQLezi/CUADROS.jpg',
  isImage: true
}, {
  label: 'Llaveros',
  img: 'https://cdn.magicpatterns.com/uploads/44TUJUhdeAP8w2uHGztV1w/LLAVEROS.png',
  isImage: true
}, {
  label: 'Souvenirs',
  img: 'https://cdn.magicpatterns.com/uploads/simdnUEco9428a6VUFmcgX/SOUVENIRS.jpg',
  isImage: true
}, {
  label: 'Fechas especiales',
  img: 'https://cdn.magicpatterns.com/uploads/66zNY8Baskk3WbogSCs7fe/REGALOS_FECHAS_ESPECIALES.jpg',
  isImage: true
}];
export function Gallery() {
  const scrollToPurchase = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 bg-deco-card" data-id="element-72">
      <div className="max-w-5xl mx-auto" data-id="element-73">
        <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-14" data-id="element-74">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl text-deco-text mb-6 font-bold leading-tight" data-id="element-75">
            Mirá todo lo que podés crear con Flores de Chenille Deco
          </h2>
          <p className="text-base sm:text-lg text-deco-taupe font-medium" data-id="element-76">
            Con una técnica simple podés crear mucho más que flores sueltas:
            podés armar productos decorativos, personalizados y vendibles para
            diferentes ocasiones.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 lg:gap-8 mb-10" data-id="element-77">
          {galleryItems.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={`group relative rounded-[1.5rem] sm:rounded-[2rem] overflow-hidden aspect-[16/9] sm:aspect-[4/3] shadow-sm border border-deco-warm flex flex-col items-center justify-center p-6 sm:p-8 ${item.isImage ? 'bg-deco-bg' : item.bg}`} data-id="element-78">
              {item.isImage ? <>
                  <img src={item.img} alt={item.label} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-79" />
                  <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors" data-id="element-80" />
                  <h3 className="relative z-10 text-white font-serif text-2xl sm:text-3xl font-bold text-center drop-shadow-md" data-id="element-81">
                    {item.label}
                  </h3>
                </> : <>
                  <div className="text-deco-terra mb-4 sm:mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-82">
                    {item.icon && <item.icon size={48} className="sm:w-16 sm:h-16" strokeWidth={1.5} data-id="element-83" />}
                  </div>
                  <h3 className="text-deco-text font-serif text-xl sm:text-2xl font-bold text-center" data-id="element-84">
                    {item.label}
                  </h3>
                </>}
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-85">
          <Button onClick={scrollToPurchase} variant="secondary" className="px-10 py-4 text-base" data-id="element-86">
            QUIERO APRENDER A HACERLOS
          </Button>
        </div>
      </div>
    </section>;
}